import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[dynamicComponentHost]',
  standalone: false
})
export class DynamicComponentHostDirective {
  constructor(public readonly viewContainerRef: ViewContainerRef) {}
}
